$(document).ready(function() {
    var today = new Date(Date.now());
    // start of this month
    var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    // end of last month next year
    var lastDay = new Date(today.getFullYear() + 1, today.getMonth() + 1, 31);
    if ($('#startDate').length) {
        $('#startDate').kendoDatePicker({
            value: firstDay,
            format: 'yyyy-MM-dd',
            change: function(e) {
                $('#loading-wheel').show();
                $('#commissions-chart')
                    .data('kendoChart')
                    .dataSource.read();
            }
        });

        $('#endDate').kendoDatePicker({
            value: lastDay,
            format: 'yyyy-MM-dd',
            change: function(e) {
                $('#loading-wheel').show();
                $('#commissions-chart')
                    .data('kendoChart')
                    .dataSource.read();
            }
        });

        $('#commissions-chart').kendoChart({
            dataSource: {
                transport: {
                    read: {
                        url: '/' + URLSEGMENT + '/commissionsfeed',
                        dataType: 'json',
                        data: function() {
                            return {
                                startDate: getStartDate(),
                                endDate: getEndDate()
                            };
                        },
                        type: 'POST'
                    }
                },
                change: function(e) {
                    updateChartInformation(this.data());
                },

                group: {
                    field: 'Name'
                },
                sort: {
                    field: 'Day',
                    dir: 'asc'
                }
            },
            title: {
                // text: "Daily Commissions \n Total: "
            },
            chartArea: {
                height: 380
            },
            legend: {
                position: 'top',
                visible: true
            },
            series: [
                {
                    type: 'line',
                    field: 'Total',
                    visibleInLegend: false
                }
            ],
            seriesColors: ['#fcc410'],
            categoryAxis: {
                field: 'Day',
                labels: {
                    rotation: -90,
                    template: "#= kendo.toString( new Date(value), 'MMM yyyy') #"
                }
            },
            valueAxis: {
                field: 'Total',
                majorUnit: 1000,
                visible: false
                // title: {
                //     text: "Commissions",
                //     rotation: -90
                // }
            },
            tooltip: {
                visible: true,
                template:
                    "#= dataItem.Name #'s Rewards: $ #= dataItem.Total - dataItem.Bonus # # if (dataItem.Bonus) { # <br/> Bonus Rewards: $ #= dataItem.Bonus # # } # <br/> (#= kendo.format('{0:d}', dataItem.Day) #)"
            },
            dataBound: function() {
                $('#loading-wheel').hide();
            }
        });
    }

    //buildSankey();

    $('.commissions-top .dropdown-toggle').on('click', function(event) {
        $(this)
            .parent()
            .toggleClass('open');
    });

    $('body').on('click', function(e) {
        if (
            !$('.commissions-top .dropdown').is(e.target) && // don't close popup if click within popup
            $('.commissions-top .dropdown').has(e.target).length === 0 &&
            $('.open').has(e.target).length === 0 &&
            !$('.k-animation-container').is(e.target) && // don't close popup if click within calendar chooser
            $('.k-animation-container').has(e.target).length === 0
        ) {
            $('.commissions-top .dropdown').removeClass('open');
        }
    });
});

function getStartDate() {
    return (
        $('#startDate')
            .data('kendoDatePicker')
            .value()
            .valueOf() / 1000
    );
}

function getEndDate() {
    return (
        $('#endDate')
            .data('kendoDatePicker')
            .value()
            .valueOf() / 1000
    );
}

function updateChartInformation(data) {
    var isData = typeof data['0'] !== 'undefined';
    var CurrentAffiliateTotal = 0;
    var StepAmt = 1;

    if (isData) {
        StepAmt = data[0].StepAmt;
        CurrentAffiliateTotal = data[0].CurrentAffiliateTotal;
    }

    $('#earned-val').text(CurrentAffiliateTotal);

    var start = $('#startDate')
        .data('kendoDatePicker')
        .value();
    var end = $('#endDate')
        .data('kendoDatePicker')
        .value();
    var firstDay = new Date(start.getFullYear(), start.getMonth(), 1);
    var lastDay = new Date(end.getFullYear(), end.getMonth() + 1, 0);
    // $("#commissions-chart").data("kendoChart").options.title.text =
    //     "<tspan x='300' dy='0' text-anchor='middle'>Daily commissions</tspan> " +
    //     "<tspan x='700' dy='0'text-anchor='middle'>(" + firstDay.toDateString() + " - " + lastDay.toDateString() +")</tspan>";
    // "<tspan x='500' dy='1em'text-anchor='middle'>My Total: $" + grandTotal + "</tspan>";
    $('#commissions-chart').data('kendoChart').options.categoryAxis.labels.step = StepAmt;

    firstDay = moment(firstDay).format('MMM DD YYYY');
    lastDay = moment(lastDay).format('MMM DD YYYY');
    $('.commissions-top .dates').text(firstDay + ' - ' + lastDay);
}
